import React from "react";

function Footer() {
  return (
    <div className="footer-container">
      <p>
        Website Development by <a href="https://sangdoesweb.github.io/">Sang</a>
      </p>
    </div>
  );
}

export default Footer;
